import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import GoToExperinceButton from "../components/GoToExperinceButton";

export default ({ isShowSuccess, handleClose }) => {
  return (
    <>
      <Modal
        show={isShowSuccess}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        // show={true}
        className="customePopup"
        dialogClassName="modal-dialog-centered modal-dialog"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <Modal.Title>
              <h1 className="title">Congratulation</h1>
            </Modal.Title>
            <div className="imgHolder">
              <img src="../imgs/tick.svg" alt="" />
            </div>
            <p>You are a part of the Cardano Crib Beta Launch</p>
            <GoToExperinceButton successCallBack={handleClose} />
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};
